export default __webpack_public_path__ + "static/media/Mardi Gras Wreath.3ec371e1.jpg";